module.exports = __webpack_public_path__ + "img/loan-offers-icon.d3a8fd22.svg";